// extracted by mini-css-extract-plugin
export default {"wrapper":"TopUp_wrapper__qDW3i","icon-container":"TopUp_icon-container__nZWRH","icon":"TopUp_icon__tSuwf","card":"TopUp_card__kTTMP"};